import { useOrderErrorAlerts } from './useOrderErrorAlerts';
import { usePaymentOverdueAccountOwnerAlert } from './usePaymentOverdueAccountOwnerAlert';
import { usePaymentOverdueNonAccountOwnerAlert } from './usePaymentOverdueNonAccountOwnerAlert';

export const useSubscriptionAlerts = (): void => {
  useOrderErrorAlerts();
  usePaymentOverdueAccountOwnerAlert();
  usePaymentOverdueNonAccountOwnerAlert();
};
